export { default, StyledGenderSwitch } from './GenderSwitch';
